import React from 'react'
import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'

import { WrapLoading } from '../../../components/helpers/Loading'
import { useDynamicServiceOrders } from './_load/DynamicServiceOrdersLoader'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Image from '../../../components/presentation/Image'
import Link from '../../../components/actions/Link'
import Logo from '../../../components/shapes/Logo'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useSaveDynamicServiceOrders } from './_requests/saveDynamicServiceOrders'
import { useColorableSpaceStyle } from '../../../packages/kiti/utils/styles/colorableSpace'

const Action = ({ onClick, icon, label, color }) => {
  const [_, fontColor] = useColorableSpaceStyle({ color })

  return (
    <Link block onClick={onClick}>
      <IconText iconSize="1.4rem" weight="700" iconName={icon} color={fontColor} label={label} noWrap />
    </Link>
  )
}

const PageHeader = () => {
  const { t } = useTranslation('common')
  const [submit, { loading }] = useSaveDynamicServiceOrders()
  const dynamicServiceOrder = useDynamicServiceOrders()

  return (
    <PageHeaderPanel
      titleContent={
        <div>
          {!!dynamicServiceOrder?.logo ? (
            <Image maxHeight={`3.5rem`} width={`6.5rem`} src={dynamicServiceOrder?.logo.src} alt="custom_logo" />
          ) : (
            <Logo white />
          )}
        </div>
      }
      smallPaddingTopBottom
      noContainer
      noWrap
      bgColor={dynamicServiceOrder?.themeColor}
      side={
        <WrapLoading loading={loading} bgColor={COLORS.menu + '90'} color={COLORS.white}>
          <FlexGrid justify="flex-end" gutter={1}>
            <Action icon="BsCheckCircle" label={t('submit')} onClick={submit} color={dynamicServiceOrder?.themeColor} />
          </FlexGrid>
        </WrapLoading>
      }
    />
  )
}

export default PageHeader
